export default __webpack_public_path__ + "static/media/include_4@3x.9e7180b3.jpg";